import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SearchModule } from '../../../shared/components/search/search.module';
import { ShortDatePipe } from '../../../shared/pipes/short-date.pipe';
import { VehicleAddModule } from '../../../vehicle/components/shared/vehicle/vehicle-add/vehicle-add.module';
import { VehicleAddModalModule } from '../../components/shared/vehicle/vehicle-add-modal/vehicle-add-modal.module';
import { VehicleDetailsModule } from '../../components/shared/vehicle/vehicle-details/vehicle-details.module';
import { VehicleInformationCoreModule } from '../../components/shared/vehicle/vehicle-information/vehicle-information-core.module';
import { VehicleSearchResultsComponent } from './vehicle-search-results.component';
import { VehicleSearchComponent } from './vehicle-search.component';
import { VehicleSearchService } from './vehicle-search.service';

@NgModule({
    declarations: [
        VehicleSearchComponent,
        VehicleSearchResultsComponent
    ],
    providers: [
        ShortDatePipe,
        VehicleSearchService
    ],
    imports: [
        CommonModule,
        SearchModule,
        TableModule,
        VehicleAddModalModule,
        VehicleAddModule,
        VehicleDetailsModule,
        VehicleInformationCoreModule
    ],
    exports: [
        VehicleSearchComponent,
        VehicleSearchResultsComponent
    ]
})
export class VehicleSearchModule {
}
